import { Component, inject, input, OnInit, output } from "@angular/core";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faFileExport, faFilter, faGear, faPlus, faPrint } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe } from "@ngx-translate/core";

import { PermissionActionDescriptorType } from "../../../../../adaa-types";
import { HasPermissionDirective } from "../../../directives";
import { CustomTableButton } from "../../../models";

@Component({
  selector: "adaa-data-table-buttons",
  imports: [TranslatePipe, FontAwesomeModule, HasPermissionDirective],
  templateUrl: "./data-table-buttons.html",
  styleUrl: "./data-table-buttons.scss",
})
export class DataTableButtonsComponent implements OnInit {
  enableAdd = input<boolean>(true);
  enablePrint = input<boolean>(false);
  enableSettings = input<boolean>(true);
  enableFilter = input<boolean>(true);
  enableExport = input<boolean>(true);
  customTableButtons = input<CustomTableButton[]>([]);
  isFilterApplied = input<boolean>(false);

  createPermission = input.required<PermissionActionDescriptorType>();

  addNewClicked = output<void>();
  printClicked = output<boolean>();
  filterClicked = output<boolean>();
  settingsClicked = output<boolean>();
  exportClicked = output<boolean>();
  buttonClicked = output<string>();

  private _iconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public ngOnInit(): void {
    this._iconLibrary.addIcons(faPlus, faGear, faFilter, faPrint, faFileExport);
  }
}
